import { Flex, Paper, Image, Title, Text, Space, Popover } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from '../../../app.module.css';
import { Link, useNavigate } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { calculateCategory } from '../util';
import { useKeycloakStore } from '../../../shared_stores';
import { getReportCategoryFromParameter } from '../stores';
import { Parameters } from '@web/common';

export const ParameterMeter = ({
  imageUrl,
  parameter,
  value,
  thresholds,
}: {
  imageUrl: string;
  parameter: Parameters;
  value: number | undefined;
  thresholds: number[] | undefined;
}) => {
  const { t } = useTranslation(['common', 'reports']);
  const canBeRendered =
    value !== undefined && thresholds && thresholds.length === 4;
  const kcStore = useKeycloakStore();
  const navigate = useNavigate();

  function caluclatePos(value: number, thresholds: number[]) {
    const rangeStart = thresholds[0] - (thresholds[1] - thresholds[0]);
    const rangeEnd = thresholds[3] + (thresholds[3] - thresholds[2]);
    if (value <= 0) {
      return 0;
    }
    if (value > rangeEnd) {
      return 100;
    }
    return (100 * value) / (rangeEnd - rangeStart);
  }

  return (
    <Paper
      className={classes.parameterMeterPaper}
      onClick={() => {
        if (kcStore.authenticated) {
          void navigate(
            `/reports/${getReportCategoryFromParameter(parameter)}?parameter=${parameter}`,
          );
        }
      }}
    >
      <Flex direction="row" style={{ height: '100%' }}>
        <Flex
          direction={'row'}
          justify={'center'}
          style={{ paddingRight: 'var(--mantine-spacing-md)' }}
        >
          <Flex
            style={{ height: '100%' }}
            direction={'column'}
            justify={'flex-start'}
          >
            <Image src={imageUrl} />
          </Flex>
        </Flex>
        <Flex direction="column">
          <Title order={3} style={{ lineHeight: 1 }}>
            {t(`reports:${parameter}`)}
          </Title>
          {canBeRendered && (
            <Text>{t(`reports:${calculateCategory(value, thresholds)}`)}</Text>
          )}
        </Flex>
      </Flex>
      <Space h={'var(--mantine-spacing-md)'} />
      {canBeRendered ? (
        <Flex direction={'row'} style={{ position: 'relative' }}>
          {['#0082FA', '#66B4FC', '#99CDFD', '#C4DEF6', '#E5F2FE'].map(
            (entry) => (
              <div
                style={{
                  height: 'var(--mantine-spacing-md)',
                  flexGrow: 1,
                  background: entry,
                }}
              />
            ),
          )}
          <Image
            src={'/../../../../assets/img/indicator.svg'}
            style={{
              height: 'auto',
              width: '20px',
              position: 'absolute',
              bottom: 0,
              left: `calc(-10px + ${caluclatePos(value, thresholds)}%)`,
            }}
          />
        </Flex>
      ) : (
        <Popover>
          <Popover.Target>
            <Flex>
              <Flex direction={'column'} justify={'end'}>
                <InfoOutlinedIcon
                  style={{
                    fill: 'var(--mantine-color-otherGrey60-0)',
                    fontSize: 20,
                  }}
                />
              </Flex>
              <Text>&nbsp;{t('reports:unable_to_render_warning')}</Text>
            </Flex>
          </Popover.Target>
          <Popover.Dropdown
            w={300}
            style={{ backgroundColor: 'var(--mantine-color-clinicalWhite-0)' }}
          >
            <Text>
              {t('reports:unable_to_render_helptext')}
              <Link
                to={'/'}
                style={{
                  textDecoration: 'underline',
                }}
              >
                {t('support_team')}
              </Link>
            </Text>
          </Popover.Dropdown>
        </Popover>
      )}
    </Paper>
  );
};
